// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "c473e9eb" + "." + "19c82f1f5a9d7542" + ".js";
};